import type {OrganizationInfo} from './types';

export class ApiError extends Error {
  status: number;
  code: string | undefined;

  constructor(status: number, message: string, code?: string) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

export class NotFoundError extends ApiError {
  constructor() {
    super(404, 'Not found');
  }
}

export class AccessDeniedError extends ApiError {
  organization: OrganizationInfo | undefined;

  constructor(organization?: OrganizationInfo) {
    super(403, 'Access denied');
    this.organization = organization;
  }
}

export class RateLimitedError extends ApiError {
  constructor() {
    super(429, 'Rate limited');
  }
}
